import React, { CSSProperties } from 'react';
import * as messages from '@radnuc/messages';
import { withTranslation } from 'react-i18next';

import { AuthenticationInterface } from './AuthenticationDisplay';
//import { ExpertSettingsDisplayInterface } from './ExpertSettingsDisplay';
import Config, {setConfig} from './Config'
import snooze_white_icon from './img/ic_snooze_32_white.png'
import snooze_icon from './img/ic_snooze_32.png'

import './ExpertSettingsDisplay.css'
import './SnoozeIsotopeDisplay.css'

import { t } from 'i18next';
import './i18n';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;

export interface SnoozeIsotopeDisplayInterface { open: () => void, close: () => void }

export interface SnoozeIsotopeDisplayProps {
    config: Config,
    authenticationInterface?: AuthenticationInterface
}
export interface SnoozeIsotopeDisplayState {menuOpen:boolean}

export class SnoozeIsotopeDisplay extends React.Component<SnoozeIsotopeDisplayProps, SnoozeIsotopeDisplayState> {
    constructor(props: SnoozeIsotopeDisplayProps) {
        super(props)
        this.state = {
            menuOpen: false
        }

        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        //TODO launch Component Config
        this.setState(() => ({
            menuOpen: true
        }));
    }

    render() {
        const snoozeIsotopeDisplayInterface = {
            open: () => this.setState({ menuOpen: true }),
            close: () => this.setState({ menuOpen: false })
        }
        let snoozeIsotopeList;
        //if(this.props.systemConfigurationInterface){
            snoozeIsotopeList =
                <div className="status-metric-container vertical-padding">
                    <label className="status-metric-title">{t('Snoozed Isotopes',{ns:'trans'})}</label>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div id="open-snooze-menu" className={"round-skinny-button"}
                            onClick={() => this.handleSelection()}>{t('Open',{ns:'trans'})}</div>
                    </div>
                    <SnoozeIsotopeListDisplay menuOpen={this.state.menuOpen} config={this.props.config}
                        snoozeIsotopeDisplayInterface={snoozeIsotopeDisplayInterface}
                        authenticationInterface={this.props.authenticationInterface}/>
                </div>
        //}
        return (
            <>
            {snoozeIsotopeList}
            </>
        )
    }
} withTranslation()

export default SnoozeIsotopeDisplay

//******************************************************************************
export interface SnoozeIsotopeListDisplayProps {
    menuOpen: boolean,
    config: Config,
    snoozeIsotopeDisplayInterface: SnoozeIsotopeDisplayInterface,
    authenticationInterface?: AuthenticationInterface
}

export interface SnoozeIsotopeListDisplayState {
    muteList: messages.ConfigurationState.IsotopeMute[],
}

export class SnoozeIsotopeListDisplay extends React.Component<SnoozeIsotopeListDisplayProps> {
    constructor(props: SnoozeIsotopeListDisplayProps) {
        super(props)

        this.state = {muteList:[]}
        this.handleMenuCloseButtonClick = this.handleMenuCloseButtonClick.bind(this);

        }
        handleMenuCloseButtonClick() {
            this.props.snoozeIsotopeDisplayInterface.close();
        }
        async setUnsnoozeIsotope(isotopeName: string) {
            console.log('Set unmute isotope: ' + isotopeName);

            if(!isotopeName.includes("UNKNOWN")){
                //Send mute for this_id with config_monitor
                let muteList = [];
                let muteIsotope = new messages.ConfigurationState.IsotopeMute();
                muteIsotope.name = isotopeName;
                muteIsotope.mute = false;
                muteList.push(muteIsotope);
                let config = new messages.ConfigurationState.InvestigationConfig();
                config.muteList = muteList;

                let message = new messages.ConfigurationState.ConfigMessage();
                message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
                message.component = messages.ConfigurationState.ConfigComponent.INVESTIGATION;
                message.inv = config;

                await setConfig(message);
            }
        }

        handleUnsnoozeThisIsotope(isotopeName: string) {
            if(this.props.authenticationInterface){
                this.props.authenticationInterface.authenticate(()=>this.setUnsnoozeIsotope(isotopeName));
            } else {
                this.setUnsnoozeIsotope(isotopeName);
            }
        }

        timeDifference(current:Date, future:Date) {
            var msPerMinute = 60 * 1000;
            var msPerHour = msPerMinute * 60;
            var msPerDay = msPerHour * 24;
            var msPerMonth = msPerDay * 30;
            var msPerYear = msPerDay * 365;

            var timeleft = future.getTime() - current.getTime();
            if (timeleft <= 0) {
                return t('DONE',{ns:'trans'});
            }
            if (timeleft < msPerMinute) {
                return  t('s left',{number: Math.round(timeleft / 1000),ns:'trans'});
                //return '< 1m left'
            } else if (timeleft < msPerHour) {
                return  t('m left',{number: Math.round(timeleft / msPerMinute),ns:'trans'});
            } else if (timeleft < msPerDay) {
                return  t('h left',{number: (timeleft / msPerHour).toFixed(1),ns:'trans'});
            } else if (timeleft < msPerMonth) {
                return t('d left',{number: Math.round(timeleft / msPerDay),ns:'trans'});
            } else if (timeleft < msPerYear) {
                return t('mo left',{number: Math.round(timeleft / msPerMonth),ns:'trans'});
            } else {
                return t('y left',{number: Math.round(timeleft / msPerYear),ns:'trans'});
            }
        }

        make_snoozed_isotope_list(){
            let snoozedIsotopeList:JSX.Element[] = [];
            if (this.props.config.inv) {
                if(this.props.config.inv.muteList !== null){
                    let muteList = this.props.config.inv.muteList;
                    if(muteList.length > 0){
                        muteList.forEach((isotope)=>{
                            const expiry = isotope.expiry;
                            const timeLeftString = '('+this.timeDifference(new Date(), new Date(expiry))+')';
                            if(isotope.mute && (new Date().getTime() - new Date(expiry).getTime() < -5000)){

                                const this_isotope =
                                    <div key={isotope.name} className="snooze-dialog" style={{display:'flex', flexDirection:'row', justifyContent:'space-between',
                                        alignItems:'baseline', padding:'0px', paddingTop:'5px',fontSize:'1em'}}>
                                        <label className="snooze-checkmark-container snooze-dialog " id={isotope.name}>
                                            {t(hyphenated_nuclide_name(isotope.name),{ns:'trans'})}
                                        </label>
                                        <label className="snooze-checkmark-container snooze-dialog ">
                                            {timeLeftString}
                                        </label>
                                        <div id="snooze-isotope-button" className="snooze-dialog dropdownevent snooze-isotope-button round-skinny-button"
                                            style={{fontSize:'1em',padding:'5px', paddingTop:'2px'}}
                                            onClick={() => this.handleUnsnoozeThisIsotope(isotope.name)}>
                                                {t('Unmute',{ns:'trans'})}
                                            </div>
                                    </div>
                                snoozedIsotopeList.push(this_isotope)
                            }
                        });
                    } else {
                        //Mutelist is empty
                    }
                }
            }
            return (snoozedIsotopeList);
        }

        componentDidUpdate(prevProps: SnoozeIsotopeDisplayProps) {
            if (this.props.config.inv?.muteList !== prevProps.config.inv?.muteList) {
                if (this.props.config.inv) {
                    const this_inv = this.props.config.inv;
                    if(this_inv.muteList !== null){
                        this.setState(state => ({
                            muteList: this_inv.muteList
                        }));
                    }
                }
            }
        }

        render() {
            let sidenavClassName = "sidenav";
            if (this.props.menuOpen) {
                sidenavClassName += " open"
            }

            const snoozedIsotopeList = this.make_snoozed_isotope_list();
            let snoozedIsotopeListDisplay;
            if(snoozedIsotopeList.length > 0){
                snoozedIsotopeListDisplay =
                    <div>
                        {snoozedIsotopeList}
                    </div>
            } else {
                snoozedIsotopeListDisplay =
                    <div>
                        <label className="snooze-checkmark-container snooze-dialog ">
                            {t('NO SNOOZED ISOTOPES',{ns:'trans'})}
                        </label>
                    </div>
            }
            const settingsContainer =
                <div id="component-settings-container" className={sidenavClassName} style={{opacity:1}}>
                    <div className="sidenav-menu" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div className="status-metric-container">
                            <label className="status-metric-title-big">{t('Snoozed Isotopes',{ns:'trans'})}</label>
                        </div>
                        <div className="closebtn" style={{ cursor: 'pointer' }} onClick={this.handleMenuCloseButtonClick}>&times;</div>
                        </div>
                        <div className="sidenav-container">

                        <div>
                            {snoozedIsotopeListDisplay}
                        </div>
                        <br></br>

                    </div>
                </div>

            return (
                <>
                {settingsContainer}
                </>
            )
    }
}

//******************************************************************************

export interface SnoozeIsotopeButtonDisplayProps {
    investigation: Investigation;
    linked_dialog_showing: boolean | null;
    style: CSSProperties | undefined;
    authenticationInterface?: AuthenticationInterface;
}

export interface SnoozeIsotopeButtonDisplayState {
    snooze_dropdown_show: boolean | null;
}

export class SnoozeIsotopeButtonDisplay extends React.Component<SnoozeIsotopeButtonDisplayProps, SnoozeIsotopeButtonDisplayState, {}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: SnoozeIsotopeButtonDisplayProps) {
        super(props)
        this.state = {
            snooze_dropdown_show: false,
        }
        this.timeoutTimer = null;

        this.handleSnoozeClick = this.handleSnoozeClick.bind(this);
        this.handleSnoozeThisIsotope = this.handleSnoozeThisIsotope.bind(this);
    }

/*
    displayShareSuccess() {
        this.setState(state => ({
            share_success_state: 1
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    displayShareFail() {
        this.setState(state => ({
            share_success_state: 2
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }
*/

    handleSnoozeClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            snooze_dropdown_show: !state.snooze_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.snooze_dropdown_show) {
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    snooze_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }

    async setSnoozeIsotope(isotopeName: string) {
        console.log('Set mute isotope: ' + isotopeName);

        if(!isotopeName.includes("UNKNOWN")){
            //Send mute for this_id with config_monitor
            let muteList = [];
            let muteIsotope = new messages.ConfigurationState.IsotopeMute();
            muteIsotope.name = isotopeName;
            muteIsotope.mute = true;
            muteList.push(muteIsotope);
            let config = new messages.ConfigurationState.InvestigationConfig();
            config.muteList = muteList;

            let message = new messages.ConfigurationState.ConfigMessage();
            message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
            message.component = messages.ConfigurationState.ConfigComponent.INVESTIGATION;
            message.inv = config;

            await setConfig(message);
        }
    }

    handleSnoozeThisIsotope(event: React.MouseEvent<HTMLElement>,isotopeName: string) {
        event.stopPropagation();
        this.setState(state => ({
            snooze_dropdown_show: false
        }));

        if(this.props.authenticationInterface){
            this.props.authenticationInterface.authenticate(()=>this.setSnoozeIsotope(isotopeName));
        } else {
            this.setSnoozeIsotope(isotopeName);
        }
    }

    componentDidUpdate() {
        if (this.props.linked_dialog_showing && this.state.snooze_dropdown_show) {
            this.setState(state => ({
                snooze_dropdown_show: false
            }));
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
    }

    make_isotope_mute_item(isotope:messages.Rad.IsotopeResult){
        return (
            <div key={isotope.name} className="snooze-dialog" style={{display:'flex', flexDirection:'row', justifyContent:'space-between',
                alignItems:'baseline',backgroundColor:'rgb(32,32,32)', padding:'0px', paddingTop:'5px',fontSize:'1em'}}>
                <label className="snooze-checkmark-container snooze-dialog " id={isotope.name}>
                    {hyphenated_nuclide_name(isotope.name)}
                </label>
                <div id="snooze-isotope-button" className="snooze-dialog dropdownevent snooze-isotope-button round-skinny-button"
                    style={{fontSize:'1em',padding:'5px', paddingTop:'2px'}}
                    onClick={(event) => this.handleSnoozeThisIsotope(event,isotope.name)}>
                        {t('Mute',{ns:'trans'})}
                    </div>
            </div>
        )
    }

    render() {
        //Buttons
        let snoozeMenuItems:JSX.Element[] = [];
        if('type' in this.props.investigation){
            if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                if(this.props.investigation.isotopes.length > 0){
                    this.props.investigation.isotopes.forEach((isotope)=>{
                        if(!isotope.name.includes("UNKNOWN")){
                            const this_isotope = this.make_isotope_mute_item(isotope);
                            snoozeMenuItems.push(this_isotope)
                        }
                    });
                }
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                //Export options for CHEM Inv
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                //Export options for BIO Inv
            }
        } else {
            if(this.props.investigation.isotopes.length > 0){
                this.props.investigation.isotopes.forEach((isotope)=>{
                    if(!isotope.name.includes("UNKNOWN")){
                        const this_isotope = this.make_isotope_mute_item(isotope);
                        snoozeMenuItems.push(this_isotope)
                    }
                });
            }
        }

        let snooze_dropdown;
        if (!this.props.linked_dialog_showing && this.state.snooze_dropdown_show) {
            snooze_dropdown =
                <div className="inv-snooze-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                    <div className="plot-title dropdown snooze-dropdown-surrogate"></div>
                    <div id="snooze-dropdown-content" className="dropdown-content snooze-dropdown show" style={this.props.style}>
                        <div className="plot-header" style={{ background: 'orange' }}>
                            <label className="plot-title " style={{ color: 'black', fontSize: '1em' }}>{t('Snooze Isotope',{ns:'trans'})}</label>
                        </div>
                        {snoozeMenuItems}
                    </div>

                </div>
        }

        let snooze_status;
        /*
        if (this.state.share_success_state === 1) {
            share_status =
                <img src={green_check_logo} alt="Success" className="inv-share-success inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else if (this.state.share_success_state === 2) {
            share_status =
                <img src={red_x_logo} alt="Fail" className="inv-share-fail inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else {
            */
            if (this.state.snooze_dropdown_show) {
                snooze_status =
                    <img src={snooze_white_icon} alt="Snooze" className="inv-snooze-open inv-menu-button dropdownevent plot-title dropdown" id="snooze-select-dropdown" style={{ cursor: 'pointer'}} onClick={this.handleSnoozeClick}></img>
            } else {
                snooze_status =
                    <img src={snooze_icon} alt="Snooze" className="inv-snooze inv-menu-button dropdownevent plot-title dropdown" id="snooze-select-dropdown" style={{ cursor: 'pointer'}} onClick={this.handleSnoozeClick}></img>
            }
        //}

        let snooze_button =
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <div id="snooze-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    {snooze_dropdown}
                    <div className="inv-snooze-container inv-menu-item">
                        {snooze_status}
                    </div>
                    <div className="inv-snooze-hidden" style={{ display: 'none'}} onClick={()=>{console.log('click')}}/>
                </div>
            </div>


        return (snooze_button);
    }
}

//Support functions for investigation card generateion
function hyphenated_nuclide_name(underscore_name: string) {
    var output = underscore_name;
    if (underscore_name.includes("_")) {
        var res = underscore_name.split("_");
        var nuclide_symbol = res[0].toLowerCase();
        var nuclide_number = res[1];
        output = nuclide_symbol[0].toUpperCase() + nuclide_symbol.slice(1) +
            "-" + nuclide_number.toLowerCase();
    }
    return output;
}

export function checkSnoozeState(pcs_result: messages.Rad.PCSResult, config: Config){
        var result = false;
        var numIsotopesAlarmingNotMuted = 0;
        var isAlarming = false;

        //Find dominant isotope its pcs value
        var max_pcs_val = 0;
        if(pcs_result){
            pcs_result.pcs_result.forEach(function(isotope) {
                if (isotope.pcs_value > max_pcs_val && isotope.alarm) {
                    max_pcs_val = isotope.pcs_value
                    isAlarming = true;
                }
            });
            if(isAlarming){
                pcs_result.pcs_result.forEach((isotope) => {
                    if (isotope.alarm && (isotope.pcs_value > max_pcs_val*0.1)) {
                        //Check if isotope is on the mute list
                        if(isMuted(isotope.name, config)){
                            result = true;
                        } else {
                            numIsotopesAlarmingNotMuted++;
                        }
                    }
                });
                //If there are any alarm on non-muted isotope, then don't mute
                if(numIsotopesAlarmingNotMuted > 0){
                    result = false;
                }
            }
        }
        return result;
}
export function isMuted(isotope:string, config:Config){

    //Current muteList
    let muteList:messages.ConfigurationState.IsotopeMute[] = []
    if (config.inv) {
        if(config.inv.muteList !== null){
            muteList = config.inv.muteList;
        }
    }

    var result = false;
    if(muteList != null){
        if(muteList.length > 0){
            muteList.forEach(function(muted_isotope) {
                if(isotope == muted_isotope.name && muted_isotope.mute){
                    result = true;
                }
            });
        }
    }
    return result;
}
